import { render, staticRenderFns } from "./landpage.vue?vue&type=template&id=2957d41b&scoped=true&"
import script from "./landpage.vue?vue&type=script&lang=js&"
export * from "./landpage.vue?vue&type=script&lang=js&"
import style0 from "./landpage.vue?vue&type=style&index=0&id=2957d41b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2957d41b",
  null
  
)

export default component.exports